import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AsyncState, createAsyncState } from './async-state';

@Component({
  standalone: false,
  selector: 'app-shared-async-state',
  templateUrl: './shared-async-state.component.html',
  styleUrls: ['./shared-async-state.component.scss'],
})
export class SharedAsyncStateComponent {
  @Input() state: AsyncState<unknown> = createAsyncState();
  @Input() empty = false;
  @Input() loadingLabel = 'Cargando...';
  @Input() refreshingLabel = 'Actualizando...';
  @Input() emptyLabel = 'No hay datos disponibles.';
  @Input() errorLabel = 'No se pudo cargar la información.';
  @Input() retryLabel = 'Reintentar';

  @Output() readonly retry = new EventEmitter<void>();

  get hasData(): boolean {
    return this.state.data !== null;
  }

  get showsRefreshFeedback(): boolean {
    return this.state.status === 'refreshing'
      || (this.state.status === 'loading' && this.hasData);
  }

  get showsBlockingError(): boolean {
    return this.state.status === 'error' && !this.hasData;
  }

  get showsInlineError(): boolean {
    return this.state.status === 'error' && this.hasData;
  }

  requestRetry(): void {
    this.retry.emit();
  }
}
